import { useState } from 'react';
import { SearchWidget } from './SearchWidget';
import { SearchDialog } from './SearchDialog';

interface SearchProps {}

export const Search = (props: SearchProps) => {
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const searchParams = new URLSearchParams(window.location.search);
  const searchText = searchParams.get('st') || '';
  const setSearchText = (newText: string) => {
    window.location.href = '/test/results?st=' + encodeURIComponent(newText);
  };
  return (
    <>
      <SearchWidget
        searchText={searchText}
        setSearchText={setSearchText}
        showFilterDialog={showFilterDialog}
        toggleFilterDialog={() => setShowFilterDialog(!showFilterDialog)}
      />
      {showFilterDialog && <SearchDialog />}
    </>
  );
};
